module.exports = __webpack_public_path__ + "img/freespin_multiplier.7ef7dc1a.png";